module.exports = __webpack_public_path__ + "img/item2.f219f152.png";